<template>
<div class="chapter">
<div class="inner_page">
<p class="center2"><span>I am down on my knees at those wireless knobs.</span></p>
<p class="center-1"><span><b>—Van Morrison</b></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter.vue?3b7b27e2